import $store from '@/store'
import checkPermission from '@/utils/permission'
import { getAllPrivilegeByUserId } from '@/api/user'
import StrUtils from '@/utils/StrUtils'

export class MultiCompanyUtil {
  // 实例集合
  static instanceMap = new Map()

  constructor() {
    this._OfficesMap = {}
    this._OfficesForApproveMap = {}
    this._user = $store.getters.userInfo
    this._isAdmin = $store.getters.isAdmin
    getAllPrivilegeByUserId().then(res => {
      this._roles = res.data
    })
  }

  get OfficesMap() {
    return this._OfficesMap
  }

  set OfficesMap(value) {
    this._OfficesMap = value
  }

  get OfficesForApproveMap() {
    return this._OfficesForApproveMap
  }

  set OfficesForApproveMap(value) {
    this._OfficesForApproveMap = value
  }

  get user() {
    return this._user
  }

  set user(value) {
    this._user = value
  }

  get roles() {
    return this._roles
  }

  set roles(value) {
    this._roles = value
  }

  static getInstance() {
    const userId = $store.getters.userId
    let instance = this.instanceMap.get(userId)
    if (!instance) {
      instance = new MultiCompanyUtil()
      this.instanceMap.set(userId, instance)
    }
    return instance
  }

  /**
   *  只有角色的权限里含有某个权限时，这个分公司才会计入
   *  如某人是青岛整箱运价Manager，同时是上海的某个角色(与运价无关)，因此他只能看到青岛的运价，不应看到上海的Cost运价。所以此时上海分公司不能计入
   * @param claze
   * @param category
   * @return
   */
  getOfficeIDs2(claze, category) {
    const prop = 'ofcIDs_' + claze
    if (this._OfficesMap.hasOwnProperty(prop)) {
      return this._OfficesMap[prop]
    }
    // 获取当前用户所在的公司
    const ofcIDs = []
    if (this._user.userId === 1 || this._user.type === 2 || this._isAdmin) {
      ofcIDs.push(1) // 管理员
      this._OfficesMap[prop] = ofcIDs
      return ofcIDs
    }
    if (!this._roles || this._roles.length === 0) return null
    // 查找公司ID
    let id = -1
    for (const role of this._roles) {
      if (!role.officeId) continue
      id = role.officeId
      // 判断是否为总部的员工，如果总部的员工，可以查看其他分公司的运价，且需要把总部ID放在ofcIDs数组中第一个元素位置上。
      if (id === 1) {
        ofcIDs.unshift(id)// 总部的员工
        this._OfficesMap[prop] = ofcIDs
        return ofcIDs
      }
      if (!ofcIDs.includes(id) && role.category && category === role.category.substr(0, category.length)) {
        ofcIDs.push(id)
      }
    }
    ofcIDs.unshift(0)// 普通员工
    this._OfficesMap[prop] = ofcIDs
    return ofcIDs
  }
  isHQManager(claze) {
    if (this._isAdmin) return true
    const category = this.getCategory(claze)
    if (category === '') return false
    if (checkPermission([category])) return false
    // 获取当前用户所在的公司
    if (!this._roles || this._roles.length === 0) return null
    // 查找公司ID
    let id = -1
    for (const role of this._roles) {
      if (StrUtils.isEmpty(role['departmentId'])) continue
      if (!role.officeId) {
        continue
      }
      id = role.officeId
      if (id === 1) {
        if (category === role.category) {
          return true
        }
      }
    }
    return false
  }
  /**
   * 返回有批准权限的分公司
   */
  getOfficeIDsForApprove(claze) {
    const category = this.getCategory(claze)
    if (category === '') return null
    const prop = 'ofcIDs_' + claze
    if (this._OfficesForApproveMap.hasOwnProperty(prop)) {
      return this._OfficesForApproveMap[prop]
    }
    // 获取当前用户所在的公司
    const ofcIDs = []
    if (this._user.userId === 1) {
      ofcIDs.push(1) // 管理员
      this._OfficesForApproveMap[prop] = ofcIDs
      return ofcIDs
    }
    if (this._roles === null || this._roles.length === 0) return null
    // 查找公司ID
    let id = -1
    for (const role of this._roles) {
      if (role.roleId === 1) {
        ofcIDs.push(1, 0) // 管理员
        this._OfficesForApproveMap[prop] = ofcIDs
        return ofcIDs
      }
      if (StrUtils.isEmpty(role['departmentId'])) continue
      if (!role.officeId) continue
      id = role.officeId
      if (role.category === category) {
        ofcIDs.push(id)
        if (id === 1) {
          ofcIDs.push(1, 0) // 总部的员工
          this._OfficesForApproveMap[prop] = ofcIDs
          return ofcIDs
        }
        break
      }
    }
    ofcIDs.push(0, 0)// 普通员工
    this._OfficesForApproveMap[prop] = ofcIDs
    return ofcIDs
  }
  getCategory(claze) {
    let category = ''
    if (claze === 'PriceFcl') {
      category = 'PFA'
    }
    if (claze === 'PriceLcl') {
      category = 'PLA'
    }
    if (claze === 'PriceAir') {
      category = 'PAA'
    }
    return category
  }
  isAdminOrHQ2(claze) {
    if (this._isAdmin) return true
    let ofcIDs = null // 获取当前用户所在的公司
    if (claze === 'PriceFcl') {
      ofcIDs = this.getOfficeIDs2(claze, 'PF')
    } else if (claze === 'PriceLcl') {
      ofcIDs = this.getOfficeIDs2(claze, 'PL')
    } else if (claze === 'PriceAir') {
      ofcIDs = this.getOfficeIDs2(claze, 'PA')
    }
    if (ofcIDs === null || ofcIDs.length === 0) return false// 当前用户不属于任何公司
    if (ofcIDs[0] === 1) return true// 对于管理员和总部的员工不需过滤
    return false
  }
}
